"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketPlayed = (function () {
    function TicketPlayed(subTickets, ticketsHolder, hasJackpot) {
        if (hasJackpot === void 0) { hasJackpot = false; }
        this.ticketID = "";
        this.ticketAmount = "";
        this.numbers = [];
        this.first5Sum = "0";
        this.ballParity = "0";
        this.topColor = [];
        this.firstBallSum = "0";
        this.firstBallParity = "0";
        this.firstColor = [];
        this.lastBallSum = "0";
        this.lastBallParity = "0";
        this.lastColor = [];
        this.allColors = false;
        this.jackpotCode = "";
        this.roundID = "";
        this.currentRound = '';
        this.roundsTotal = '';
        this.winningTicket = false;
        this.hasJackpot = false;
        this.shareWins = {
            all_colors: '',
            top_color: '',
            matchedNumbers: [],
            first_color: '',
            preballs_sum: '',
            first_ball: '',
            first_five_balls: '',
            last_color: '',
            last_ball: '',
            last_ball_parity: '',
            parity: ''
        };
        this.colors = {
            1: 'red',
            2: 'green',
            3: 'blue',
            4: 'purple',
            5: 'brown',
            6: 'yellow',
            7: 'orange',
            8: 'black'
        };
        this.ballColors = {
            'red': [1, 9, 17, 25, 33, 41],
            'green': [2, 10, 18, 26, 34, 42],
            'blue': [3, 11, 19, 27, 35, 43],
            'purple': [4, 12, 20, 28, 36, 44],
            'brown': [5, 13, 21, 29, 37, 45],
            'yellow': [6, 14, 22, 30, 38, 46],
            'orange': [7, 15, 23, 31, 39, 47],
            'black': [8, 16, 24, 32, 40, 48]
        };
        this.ticketsHolder = ticketsHolder;
        for (var key in subTickets) {
            this.ticketID = subTickets[key]['TicketID'];
            this.ticketAmount = subTickets[key]['TicketAmount'];
            this.jackpotCode = subTickets[key]['JPCode'];
            this.roundID = subTickets[key]['RoundID'];
            this.currentRound = subTickets[key]['CurrentRound'];
            this.roundsTotal = subTickets[key]['RoundsTotal'];
            this.hasJackpot = hasJackpot;
            switch (subTickets[key]['OddType']) {
                case 1:
                    if (subTickets[key]['Numbers'] == "|01|09|17|25|33|41|02|10|18|26|34|42|03|11|19|27|35|43|04|12|20|28|36|44|05|13|21|29|37|45|06|14|22|30|38|46|07|15|23|31|39|47|08|16|24|32|40|48|") {
                        this.allColors = true;
                    }
                    else {
                        this.numbers = this.decodeNumbers(subTickets[key]['Numbers']);
                    }
                    break;
                case 2:
                    this.first5Sum = subTickets[key]['Odd'];
                    break;
                case 3:
                    this.firstBallSum = subTickets[key]['Odd'];
                    break;
                case 4:
                    this.firstBallParity = subTickets[key]['Odd'];
                    break;
                case 5:
                    this.firstColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
                case 6:
                    this.ballParity = subTickets[key]['Odd'];
                    break;
                case 7:
                    this.topColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
                case 8:
                    this.lastBallSum = subTickets[key]['Odd'];
                    break;
                case 9:
                    this.lastBallParity = subTickets[key]['Odd'];
                    break;
                case 10:
                    this.lastColor = this.decodeColors(subTickets[key]['Numbers']);
                    break;
            }
        }
    }
    TicketPlayed.prototype.compareNumbers = function (a, b) {
        return a - b;
    };
    TicketPlayed.prototype.ball2Color = function (ballNumber) {
        for (var key in this.ballColors) {
            var index = this.ballColors[key].indexOf(ballNumber);
            if (index !== -1) {
                return key;
            }
        }
        return false;
    };
    TicketPlayed.prototype.isEven = function (n) {
        return n % 2 == 0;
    };
    TicketPlayed.prototype.decodeNumbers = function (numbersString) {
        var numbers = numbersString.split('|');
        delete numbers[numbers.length - 1];
        delete numbers[0];
        var numbersNew = [];
        for (var x in numbers) {
            numbersNew.push(parseInt(numbers[x]));
        }
        return numbersNew;
    };
    TicketPlayed.prototype.decodeColors = function (colorString) {
        var colorArray = [];
        for (var i = 0; i < colorString.length; i++) {
            colorArray.push(this.number2color(parseInt(colorString.charAt(i))));
        }
        return colorArray;
    };
    TicketPlayed.prototype.number2color = function (colorCode) {
        return this.colors[colorCode];
    };
    TicketPlayed.prototype.update = function () {
        var oldWinningStatus = this.winningTicket;
        var drawnNumbers = window['drawnNumbers'];
        var drawnBalls = window['drawnBalls'];
        var drawnOddBalls = window['drawnOddBalls'];
        var drawnEvenBalls = window['drawnEvenBalls'];
        var drawnColors = window['drawnColors'];
        if (this.allColors) {
            for (var key_1 in drawnColors) {
                if (drawnColors[key_1] >= 6) {
                    $('#' + this.ticketID + '-all-color-' + key_1).addClass('bhr-balls-choosen bhr-balls-choosen-' + key_1);
                    this.winningTicket = true;
                    this.shareWins.all_colors = drawnColors;
                }
            }
        }
        if (typeof drawnNumbers === 'undefined' || drawnNumbers.length == 0) {
            console.info("drawnNumbers is undefined");
            return;
        }
        var matchedNumbers = 0;
        var matchNumbersArr = [];
        for (var key in drawnNumbers) {
            if (document.getElementById(this.ticketID + '-ball-' + drawnNumbers[key]) !== null) {
                matchedNumbers++;
                matchNumbersArr.push(drawnNumbers[key]);
            }
            $('#' + this.ticketID + '-ball-' + drawnNumbers[key]).parent().addClass('ticket-ball-bck-drawn');
        }
        if (matchedNumbers >= 6) {
            this.winningTicket = true;
            this.shareWins.matchedNumbers = matchNumbersArr.sort();
        }
        var firstColor = this.ball2Color(drawnNumbers[0]);
        $('#' + this.ticketID + '-first-color-' + firstColor).addClass('tshs-balls-drawn');
        if (document.getElementById(this.ticketID + '-first-color-' + firstColor) !== null) {
            this.winningTicket = true;
            this.shareWins.first_color = firstColor;
        }
        var firstSum = parseInt(drawnNumbers[0]);
        if (this.isEven(firstSum)) {
            $('#' + this.ticketID + '-first-ball-parity-even').addClass('tsh-cr-down-red-drawn');
            if (document.getElementById(this.ticketID + '-first-ball-parity-even') !== null) {
                this.winningTicket = true;
                this.shareWins.preballs_sum = 'Even';
            }
        }
        else {
            $('#' + this.ticketID + '-first-ball-parity-odd').addClass('tsh-cr-down-red-drawn');
            if (document.getElementById(this.ticketID + '-first-ball-parity-odd') !== null) {
                this.winningTicket = true;
                this.shareWins.preballs_sum = 'Odd';
            }
        }
        if (firstSum < 24.5) {
            $('#' + this.ticketID + '-first-ball-sum-less').addClass('tsh-cr-down-red-drawn');
            if (document.getElementById(this.ticketID + '-first-ball-sum-less') !== null) {
                this.winningTicket = true;
                this.shareWins.first_ball = 'Less';
            }
        }
        else {
            $('#' + this.ticketID + '-first-ball-sum-more').addClass('tsh-cr-down-red-drawn');
            if (document.getElementById(this.ticketID + '-first-ball-sum-more') !== null) {
                this.winningTicket = true;
                this.shareWins.first_ball = 'More';
            }
        }
        if (drawnBalls >= 5 && drawnNumbers.length >= 5) {
            var sum = parseInt(drawnNumbers[0]) + parseInt(drawnNumbers[1]) + parseInt(drawnNumbers[2]) + parseInt(drawnNumbers[3]) + parseInt(drawnNumbers[4]);
            if (sum < 122.5) {
                $('#' + this.ticketID + '-first-5-sum-less').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-first-5-sum-less') !== null) {
                    this.winningTicket = true;
                    this.shareWins.first_five_balls = 'Less';
                }
            }
            else {
                $('#' + this.ticketID + '-first-5-sum-more').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-first-5-sum-more') !== null) {
                    this.winningTicket = true;
                    this.shareWins.first_five_balls = 'More';
                }
            }
        }
        if (drawnBalls >= 35) {
            var lastColor = this.ball2Color(drawnNumbers[34]);
            var lastSum = parseInt(drawnNumbers[34]);
            var commonColors = window['getMostCommonColors']();
            for (var key_2 in commonColors) {
                $('#' + this.ticketID + '-top-color-' + commonColors[key_2]).addClass('tshs-balls-drawn');
                if (document.getElementById(this.ticketID + '-top-color-' + commonColors[key_2]) !== null) {
                    this.winningTicket = true;
                    this.shareWins.top_color = commonColors[key_2];
                }
            }
            $('#' + this.ticketID + '-last-color-' + lastColor).addClass('tshs-balls-drawn');
            if (document.getElementById(this.ticketID + '-last-color-' + lastColor) !== null) {
                this.winningTicket = true;
                this.shareWins.last_color = lastColor;
            }
            if (lastSum < 24.5) {
                $('#' + this.ticketID + '-last-ball-sum-less').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-last-ball-sum-less') !== null) {
                    this.winningTicket = true;
                    this.shareWins.last_ball = 'Less';
                }
            }
            else {
                $('#' + this.ticketID + '-last-ball-sum-more').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-last-ball-sum-more') !== null) {
                    this.winningTicket = true;
                    this.shareWins.last_ball = 'More';
                }
            }
            if (this.isEven(lastSum)) {
                $('#' + this.ticketID + '-last-ball-parity-even').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-last-ball-parity-even') !== null) {
                    this.winningTicket = true;
                    this.shareWins.last_ball_parity = 'Even';
                }
            }
            else {
                $('#' + this.ticketID + '-last-ball-parity-odd').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-last-ball-parity-odd') !== null) {
                    this.winningTicket = true;
                    this.shareWins.last_ball_parity = 'Odd';
                }
            }
            if (drawnOddBalls > drawnEvenBalls) {
                $('#' + this.ticketID + '-ball-parity-odd').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-ball-parity-odd') !== null) {
                    this.winningTicket = true;
                    this.shareWins.parity = 'Odd';
                }
            }
            else {
                $('#' + this.ticketID + '-ball-parity-even').addClass('tsh-cr-down-red-drawn');
                if (document.getElementById(this.ticketID + '-ball-parity-even') !== null) {
                    this.winningTicket = true;
                    this.shareWins.parity = 'Even';
                }
            }
        }
        if (this.winningTicket === true && oldWinningStatus !== true) {
            this.ticketsHolder.markWinningTicket(this.ticketID);
        }
    };
    TicketPlayed.prototype.getSharedWinsData = function () {
        return this.shareWins;
    };
    TicketPlayed.prototype.getWinStatus = function () {
        return this.winningTicket;
    };
    TicketPlayed.prototype.getHTML = function (key) {
        var translation = window['langArr'][window['language']];
        var jackpotClass = '';
        if (this.hasJackpot) {
            jackpotClass = ' lb-jackpot-ticket';
        }
        var html = '<div class="ticket-holder' + jackpotClass + '" id="ticket-' + this.ticketID + '">\
							<div class="ticket-share-confirm" id="ticket-share-confirm' + key + '">\
							<div>\
							<div>' + translation['sure2share'] + '</div>\
							<div class="tsc-yn"><span class="shareConfirmYes" data-sharekey=' + key + '>' + translation['yes'] + '</span><span class="shareConfirmNo"  data-sharekey=' + key + '>' + translation['no'] + '</span></div>\
							</div>\
							</div>\
                            <div class="ticket-bar clearfix">\
								<div class="ticket-bar-left">' + translation['ticket_id'] + ' : ' + this.ticketID + '</div>\
								<div class="ticket-bar-right"><img id="shareButton-' + this.ticketID + '" class="ticket-share-image" data-sharekey = ' + key + ' src="../shared/img/share.svg" title="' + translation['Share'] + '" /> </div>\
                                <div class="ticket-bar-right">' + this.ticketAmount + ' ' + window['currency'] + '</div>\
                            </div>\
                            <div class="ticket-content">\
                                <div class="ticket-ball-holder">';
        if (this.allColors === false) {
            this.numbers.sort(this.compareNumbers);
            for (var key_3 in this.numbers) {
                var ball = document.getElementById('ball' + this.numbers[key_3]);
                if (null !== ball) {
                    var clone = ball.cloneNode(true);
                    $(clone).attr('id', this.ticketID + '-ball-' + this.numbers[key_3]);
                    $(clone).removeClass('clickable-ball');
                    html += '                       <div class="ticket-ball-bck">';
                    html += clone.outerHTML;
                    html += '                       <div class="kvacica"></div></div>';
                }
            }
        }
        else {
            html += '<div class="bhr-content" style="padding: 0 30px 0 30px;">\
                                <div class="bhr-balls" data-color="red" id="' + this.ticketID + '-all-color-red"><img alt="red-ball" src="img/red-ball.png"></div>\
                                <div class="bhr-balls" data-color="green" id="' + this.ticketID + '-all-color-green"><img alt="green-ball" src="img/green-ball.png"></div>\
                                <div class="bhr-balls" data-color="blue" id="' + this.ticketID + '-all-color-blue"><img alt="blue-ball" src="img/blue-ball.png"></div>\
                                <div class="bhr-balls" data-color="purple" id="' + this.ticketID + '-all-color-purple"><img alt="purple-ball" src="img/purple-ball.png"></div>\
                                <div class="bhr-balls" data-color="brown" id="' + this.ticketID + '-all-color-brown"><img alt="brown-ball" src="img/brown-ball.png"></div>\
                                <div class="bhr-balls" data-color="yellow" id="' + this.ticketID + '-all-color-yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>\
                                <div class="bhr-balls" data-color="orange" id="' + this.ticketID + '-all-color-orange"><img alt="orange-ball" src="img/orange-ball.png"></div>\
                                <div class="bhr-balls" data-color="black" id="' + this.ticketID + '-all-color-black"><img alt="black-ball" src="img/black-ball.png"></div>\
                            </div>';
        }
        (this.currentRound === '' && this.roundsTotal === '') || (this.currentRound == '1' && this.roundsTotal == '1') ?
            html += '                    </div>\
                                            <div class="ticket-statistic-holder">\
                                            <div class="tsh-title"><span>' + translation['all'] + '<span></div>\
                                                <div class="tsh-content">\
                                                    <div class="tsh-content-left">\
                                                        <div class="tshs-cl-text">' + translation['common_color'] + '</div>\
                                                        <div class="tshs-balls-holder">' :
            html += '                    </div>\
                                <div class="ticket-statistic-holder">\
                                <div class="tsh-title"><span>' + translation['current_round'] + ': ' + this.currentRound + ' of </span><span>' + this.roundsTotal + ' ' + translation['rounds_total'] + '</span></div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['common_color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        for (var key_4 in this.topColor) {
            html += '                               <div class="tshs-balls ' + this.topColor[key_4] + '-ball" id="' + this.ticketID + '-top-color-' + this.topColor[key_4] + '"></div>';
        }
        for (var key_5 = 0; key_5 < 4 - this.topColor.length; key_5++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '                               </div>';
        html += '                           </div>\
                                        <div class="tsh-content-right" style="width: 53%;">\
                                            <div class="tsh-cr-up">\
                                                <span>' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.ballParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-ball-parity-even' + '"';
        }
        html += '>' + translation['more_even'] + '</span>\
                                                <span ';
        if (this.ballParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-ball-parity-odd' + '"';
        }
        html += '>' + translation['more_odd'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['first_five_balls'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-middle">\
                                            <div class="tsh-cr-up">\
                                                <span>122.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.first5Sum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-5-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.first5Sum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-5-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['first_ball'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        for (var key_6 in this.firstColor) {
            html += '                               <div class="tshs-balls ' + this.firstColor[key_6] + '-ball" id="' + this.ticketID + '-first-color-' + this.firstColor[key_6] + '"></div>';
        }
        for (var key_7 = 0; key_7 < 4 - this.firstColor.length; key_7++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '                                </div>\
                                        </div>\
                                        <div class="tsh-content-middle ths-cm-left">\
                                            <div class="tsh-cr-up">\
                                                <span>' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.firstBallParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-ball-parity-even' + '"';
        }
        html += '>' + translation['even'] + '</span>\
                                                <span ';
        if (this.firstBallParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-ball-parity-odd' + '"';
        }
        html += '>' + translation['odd'] + '</span>\
                                            </div>\
                                        </div>\
                                        <div class="tsh-content-right">\
                                            <div class="tsh-cr-up">\
                                                <span>24.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.firstBallSum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-ball-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.firstBallSum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-first-ball-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="ticket-statistic-holder">\
                                    <div class="tsh-title">' + translation['last_ball'] + '</div>\
                                    <div class="tsh-content">\
                                        <div class="tsh-content-left">\
                                            <div class="tshs-cl-text">' + translation['color'] + '</div>\
                                            <div class="tshs-balls-holder">';
        for (var key_8 in this.lastColor) {
            html += '                               <div class="tshs-balls ' + this.lastColor[key_8] + '-ball" id="' + this.ticketID + '-last-color-' + this.lastColor[key_8] + '"></div>';
        }
        for (var key_9 = 0; key_9 < 4 - this.lastColor.length; key_9++) {
            html += '                               <div class="tshs-balls"></div>';
        }
        html += '</div>\
                                        </div>\
                                        <div class="tsh-content-middle ths-cm-left">\
                                            <div class="tsh-cr-up">\
                                                <span class="tsh-cr-down">' + translation['parity'] + '</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.lastBallParity == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-last-ball-parity-even' + '"';
        }
        html += '>' + translation['even'] + '</span>\
                                                <span ';
        if (this.lastBallParity == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-last-ball-parity-odd' + '"';
        }
        html += '>' + translation['odd'] + '</span>\
                                            </div>\
                                        </div>\
                                        <div class="tsh-content-right">\
                                            <div class="tsh-cr-up">\
                                                <span>24.5</span>\
                                            </div>\
                                            <div class="tsh-cr-down">\
                                                <span ';
        if (this.lastBallSum == "1") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-last-ball-sum-less' + '"';
        }
        html += '>' + translation['less'] + '</span>\
                                                <span ';
        if (this.lastBallSum == "2") {
            html += 'class="tsh-cr-down-red" id="' + this.ticketID + '-last-ball-sum-more' + '"';
        }
        html += '>' + translation['more'] + '</span>\
                                            </div>\
                                        </div>\
                                    </div>\
                                </div>\
                                <div class="jackpot-code"><span class="tsh-cr-down-red">' + translation['round_no'] + ': ' + this.roundID + ' </span><span class="tsh-cr-down-red"">' + translation['jackpot_code'] + ': ' + this.jackpotCode + '</span></div>\
                            </div>\
                        </div>';
        return html;
    };
    TicketPlayed.prototype.getDrawnNumbers = function () {
        return window['drawnBalls'];
    };
    TicketPlayed.prototype.shareHTML = function () {
        var translation = window['langArr'][window['language']];
        var shareLost = {
            top_color: this.topColor,
            first_color: this.firstColor,
            preballs_sum: '',
            first_ball: '',
            first_five_balls: '',
            last_color: this.lastColor,
            last_ball: '',
            last_ball_parity: '',
            parity: ''
        };
        if (this.firstBallParity == "1") {
            shareLost.first_ball = 'Less';
        }
        if (this.firstBallParity == "2") {
            shareLost.first_ball = 'More';
        }
        if (this.firstBallSum == "1") {
            shareLost.preballs_sum = 'Even';
        }
        if (this.firstBallSum == "2") {
            shareLost.preballs_sum = 'Odd';
        }
        if (this.first5Sum == "1") {
            shareLost.first_five_balls = 'Less';
        }
        if (this.first5Sum == "2") {
            shareLost.first_five_balls = 'More';
        }
        if (this.lastBallSum == "1") {
            shareLost.last_ball = 'Less';
        }
        if (this.lastBallSum == "2") {
            shareLost.last_ball = 'More';
        }
        if (this.lastBallParity == "1") {
            shareLost.last_ball_parity = 'Even';
        }
        if (this.lastBallParity == "2") {
            shareLost.last_ball_parity = 'Odd';
        }
        if (this.ballParity == "1") {
            shareLost.parity = 'Even';
        }
        if (this.ballParity == "2") {
            shareLost.parity = 'Odd';
        }
        var html = '<div class="ticket-holder" >\
							</div>\
                            <div class="ticket-bar clearfix str-ticket-bar-use">\
								<div class="ticket-bar-left">str-left-use</div>\
								<div class="ticket-bar-right">str-lost-use</div>\
                                <div class="ticket-bar-right-after">str-right-use</div>\
                            </div>\
                            <div class="ticket-content">';
        if (this.allColors === false) {
            this.numbers.sort(this.compareNumbers);
            html += '<div class="ticket-ball-holder">';
            var _loop_1 = function (key) {
                var ball = document.getElementById('ball' + this_1.numbers[key]);
                var classCss = '';
                var self_1 = this_1;
                var drawnNumbers = window['drawnNumbers'];
                drawnNumbers.forEach(function (match) {
                    if (match === self_1.numbers[key]) {
                        classCss = 'ticket-ball-bck-drawn';
                    }
                });
                if (null !== ball) {
                    var clone = ball.cloneNode(true);
                    $(clone).attr('id', this_1.ticketID + '-ball-' + this_1.numbers[key]);
                    $(clone).removeClass('clickable-ball');
                    html += '                       <div class="ticket-ball-bck ' + classCss + '">';
                    html += clone.outerHTML;
                    html += '                       <div class="kvacica"></div></div>';
                }
            };
            var this_1 = this;
            for (var key in this.numbers) {
                _loop_1(key);
            }
        }
        else {
            html += '<div class="bhr-content" style="padding: 0 30px 0 30px;">\
						<div class="bhr-balls" data-color="red" id="' + this.ticketID + '-all-color-red"><img alt="red-ball" src="img/red-ball.png"></div>\
						<div class="bhr-balls" data-color="green" id="' + this.ticketID + '-all-color-green"><img alt="green-ball" src="img/green-ball.png"></div>\
						<div class="bhr-balls" data-color="blue" id="' + this.ticketID + '-all-color-blue"><img alt="blue-ball" src="img/blue-ball.png"></div>\
						<div class="bhr-balls" data-color="purple" id="' + this.ticketID + '-all-color-purple"><img alt="purple-ball" src="img/purple-ball.png"></div>\
						<div class="bhr-balls" data-color="brown" id="' + this.ticketID + '-all-color-brown"><img alt="brown-ball" src="img/brown-ball.png"></div>\
						<div class="bhr-balls" data-color="yellow" id="' + this.ticketID + '-all-color-yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>\
						<div class="bhr-balls" data-color="orange" id="' + this.ticketID + '-all-color-orange"><img alt="orange-ball" src="img/orange-ball.png"></div>\
						<div class="bhr-balls" data-color="black" id="' + this.ticketID + '-all-color-black"><img alt="black-ball" src="img/black-ball.png"></div>\
					</div>';
        }
        html += '</div>';
        for (var key in shareLost) {
            if (typeof shareLost[key] === 'string' || shareLost[key] instanceof String) {
                if (shareLost[key].length > 0) {
                    var nameKEy = '';
                    if (key === 'preballs_sum') {
                        nameKEy = 'first_ball';
                    }
                    else {
                        nameKEy = key;
                    }
                    html +=
                        '<div id="shareOther">' +
                            translation[nameKEy].toUpperCase() + ' :  <span class="green">' + translation[shareLost[key].toLowerCase()].toUpperCase() + '</span>' +
                            '</div>';
                }
            }
            else {
                if (shareLost[key].length > 0) {
                    var nameKEy = '';
                    if (key === 'preballs_sum') {
                        nameKEy = 'first_ball';
                    }
                    else {
                        nameKEy = key;
                    }
                    html +=
                        '<div id="shareOther">' +
                            translation[nameKEy].toUpperCase() + ' :  ';
                    for (var ct = 0; ct < shareLost[key].length; ct++) {
                        html += ' <span class="separate">' + translation[shareLost[key][ct].toLowerCase()].toUpperCase() + '</span>';
                    }
                    html += '</div>';
                }
            }
        }
        return html;
    };
    return TicketPlayed;
}());
exports.default = TicketPlayed;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/ticket-played.ts
// module id = 1169
// module chunks = 2